//import { filterTypes } from '@/constants'

/**
 * SORT ITEMS BY NAME
 * @param {Array} list
 * @param {String} key
 */
const orderByName = ( list, key ) => {
  const _key = !key ? 'title' : key
  return list
    .map( ( item, i ) => {
      return {
        index: i,
        field: item[_key].toLowerCase()
      }
    } )
    .sort( ( a, b ) => ( a.field === b.field ? 0 : a.field < b.field ? -1 : 1 ) )
    .map( item => list[item.index] )
}

/**
 * Order the list by date
 * @param {Array} list
 * @param {String} key
 */
const orderByDate = ( list, key ) => {
  const _key = !key ? 'created_at' : key
  return list.sort( ( a, b ) => {
    return new Date( b[_key] ) - new Date( a[_key] )
  } )
}

const filters = {
  ALPHABETICAL: orderByName,
  DATE: orderByDate
}

export const filterList = ( list, type, key ) => {
  const filter = filters[type]
  return ( !filter ? orderByDate : filter )( list, key )
}



// WEBPACK FOOTER //
// ./src/utils/filterList.js